import styles from './Contact.module.css';
import contacts from './contacts'
import { useTranslation } from 'react-i18next';

export const Contact = () => {
  const {t} = useTranslation()
  return (
    <div className={styles.contact}>
      <h1>{t("contact.contact")}</h1>
      <p>
        {t("contact.text")}
      </p>
      <div className={styles.contactsMenu}>
        {contacts.map((c, index)=>{
          const {name, value, type, icon} = c
          return <a href={type+value} key={index} className={styles.card}>
            <div className={styles['icon-wrapper']}>
              <p className={styles.icon}>{icon}</p>
            </div>
            <h4>{name}</h4>
            {type&&<p>{value}</p>}
          </a>
        })}
      </div>
    </div>
  )
}
